import PropTypes from 'prop-types';
import { useState, useEffect, useMemo } from 'react';

// third party
import { IntlProvider } from 'react-intl';
import useConfig from 'hooks/useConfig';

// load locales files
function loadLocaleData(i18n) {
  switch (i18n) {
    case 'fr':
      return import('utils/locales/fr.json');
    case 'ro':
      return import('utils/locales/ro.json');
    case 'zh':
      return import('utils/locales/zh.json');
    default:
      return import('utils/locales/en.json');
  }
}

export default function Locales({ children }) {
  const {
    state: { i18n }
  } = useConfig();
  const [messages, setMessages] = useState();

  const localeDataPromise = useMemo(() => loadLocaleData(i18n), [i18n]);
  useEffect(() => {
    localeDataPromise.then((d) => {
      setMessages(d.default);
    });
  }, [localeDataPromise]);

  // FIXED: Safe locale fallback to prevent intl warning
  const safeLocale = i18n || 'en';

  // Memoized children to avoid re-renders during load
  const memoizedChildren = useMemo(() => children, [children]);

  return (
    <>
      {messages && (
        <IntlProvider locale={safeLocale} defaultLocale="en" messages={messages}>
          {memoizedChildren}
        </IntlProvider>
      )}
    </>
  );
}

Locales.propTypes = { children: PropTypes.node };